// extracted by mini-css-extract-plugin
module.exports = {"imgWrap":"PreviewModal_imgWrap-1ddti"};